import { httpGet } from '../Util/http';
import { addAlert } from '../MsgNotify/msgNotifyActions';

export const GET_CUSTOM_PRICELISTS_SUCCESS_LIST = 'GET_CUSTOM_PRICELISTS_SUCCESS_LIST';
export const getCustomPricelistsSuccess = (customPricelists) => {
    return {
        type: GET_CUSTOM_PRICELISTS_SUCCESS_LIST,
        customPricelists
    }
}


export const SET_CUSTOMPRICELISTS_LOADING_LIST = 'SET_CUSTOMPRICELISTS_LOADING_LIST';
export const setCustomPricelistsLoading = (status) => {
    return {
        type: SET_CUSTOMPRICELISTS_LOADING_LIST,
        status,
    }
}

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const setSearchTerm = (search) => {
    return {
        type: SET_SEARCH_TERM,
        search,
    }
}

export const SET_SELECTED_PRICELIST = 'SET_SELECTED_PRICELIST';
export const setSelectedPricelist = (pricelistId) => {
    return {
        type: SET_SELECTED_PRICELIST,
        pricelistId,
    }
}


export const getCustomPricelists = () => {
    return (dispatch) => {
        const url = process.env.REACT_APP_productCatalogEndPoint + `api/custompricelist`;
        dispatch(setCustomPricelistsLoading(true))
        return httpGet(url)
            .then((resp) => resp.json())
            .then((p) => dispatch(getCustomPricelistsSuccess(p.customPricelists)))
            .then(() => dispatch(setCustomPricelistsLoading(false)))
            .catch(() => {
                dispatch(addAlert('Kunne ikke hente særprislister'))
                dispatch(setCustomPricelistsLoading(false))
            })
    }
}


// WEBPACK FOOTER //
// ./src/App/PricelistsList/actions.js